import { render, staticRenderFns } from "./avatarListViewer.vue?vue&type=template&id=a50ef956"
import script from "./avatarListViewer.vue?vue&type=script&lang=js"
export * from "./avatarListViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports